<div
  class="form-group {{
    control && !!control.invalid ? 'fg-invalid' : 'fg-valid'
  }} {{ required ? 'fg-required' : '' }} {{ settings.class }}"
  *ngIf="settings"
>
  <label for="input-{{ settings.fieldName | titlecase }}">
    {{ settings.label }}
    <span
      *ngIf="required && !disabled && !settings.disableAsterisk"
      class="text-danger required-asterisk-sign"
      >*</span
    >
  </label>
  <div
    [ngClass]="{
      'd-flex input-group align-items-center': true
    }"
    [class]="settings.customInputClass"
  >
    <input
      class="form-control  {{
        control && !!control.invalid ? 'ng-invalid' : 'ng-valid'
      }} {{ required ? 'required' : '' }}
      {{ settings.hideResetInput || disabled ? 'input-only' : '' }}
      {{ data && settings?.showFieldHasValue === true ? 'filled-out' : '' }}"
      name="dp"
      bsDatepicker
      #d="bsDatepicker"
      [bsValue]="data"
      [placeholder]="settings.placeholder || 'DD/MM/YYYY'"
      [disabled]="disabled"
      [required]="required"
      [bsConfig]="bsConfig"
      (bsValueChange)="onDateValueChange($event, 'date')"
    />
    <div class="input-group-append">
      <button
        *ngIf="!disabled"
        type="button"
        class="btn btn-outline-secondary btn-calendar input-group-text"
        [disabled]="disabled"
        (click)="d.toggle()"
      >
        <span class="oi oi-calendar"></span>
      </button>
    </div>
    <timepicker
      *ngIf="settings.showTimePicker"
      class="time-input-field"
      [(ngModel)]="data"
      [showMeridian]="settings.showMeridian"
      [showSpinners]="false"
      [showSeconds]="settings.showSeconds"
      [disabled]="disabled"
      [required]="required"
      (ngModelChange)="onDateValueChange($event, 'time')"
    ></timepicker>
    <div class="input-group-append">
      <button
        type="button"
        class="time-input-clear input-group-text"
        *ngIf="!settings.hideResetInput && !disabled"
        tabindex="-1"
        (click)="onClearInput()"
        [disabled]="disabled"
      >
        <span class="clear-text" style="display: none">Clear</span>
        <span class="oi oi-x"></span>
      </button>
    </div>
  </div>
  <div class="error-message" *ngIf="showError">
    {{ errors[0] }}
  </div>
</div>
